var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nav"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"left"},[_c('div',{staticClass:"logo",on:{"click":_vm.toHome}},[_c('img',{staticClass:"logo",attrs:{"src":require("@/assets/images/logo.jpg"),"alt":"logo"}})]),_c('div',{staticClass:"menu"},[_c('ul',[_c('li',{class:[
              'menu-item',
              {
                'menu-item-active': _vm.activeNav === 'home'
              }
            ],on:{"click":_vm.toHome}},[_vm._v(" 首页 ")]),_c('li',{class:[
              'menu-item',
              {
                'menu-item-active': _vm.activeNav === 'register'
              }
            ],on:{"click":_vm.toRegister}},[_vm._v(" 报名参赛 ")]),_c('li',{class:[
              'menu-item',
              {
                'menu-item-active': _vm.activeNav === 'register'
              }
            ],on:{"click":_vm.toNews}},[_vm._v(" 大赛动态 ")]),_c('li',{class:[
              'menu-item',
              {
                'menu-item-active': _vm.activeNav === 'register'
              }
            ],on:{"click":_vm.toInterview}},[_vm._v(" 大赛专栏 ")]),_c('li',{class:[
              'menu-item',
              {
                'menu-item-active': _vm.activeNav === 'register'
              }
            ],on:{"click":_vm.toGuide}},[_vm._v(" 投稿指南 ")]),_c('li',{class:[
              'menu-item',
              {
                'menu-item-active': _vm.activeNav === 'collections'
              }
            ],on:{"click":_vm.toCollections}},[_vm._v(" 历届作品 ")]),_c('li',{class:[
              'menu-item',
              {
                'menu-item-active': _vm.activeNav === 'experts'
              }
            ],on:{"click":_vm.toExperts}},[_vm._v(" 专家库 ")])])])]),_c('div',{staticClass:"right"},[_c('span',{class:{
          'right-active': _vm.lang === 'cn'
        },on:{"click":function($event){return _vm.changeLang('cn')}}},[_vm._v(" 中文 ")]),_c('span',[_vm._v("/")]),_c('span',{class:{
          'right-active': _vm.lang === 'en'
        },on:{"click":function($event){return _vm.changeLang('en')}}},[_vm._v(" En ")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }